import { gql } from '@/__generated__';

/**
 * Mutation: Confirm Device Document Upload (Phase 2)
 * 
 * Confirms that a file was successfully uploaded to S3 and updates
 * the device profile with the document URL.
 * 
 * This mutation should be called AFTER:
 * 1. uploadDeviceDocument mutation (to get fileKey)
 * 2. Direct upload to S3 using presigned URL
 * 3. Device profile creation (to get deviceProfileId)
 * 
 * @param deviceProfileId - ID of the device profile record
 * @param documentType - Type of document (ELECTRICAL_PLAN or DIAGRAM)
 * @param fileKey - S3 object key returned from uploadDeviceDocument
 * 
 * @returns Boolean indicating success
 */
const CONFIRM_DEVICE_DOCUMENT_UPLOAD = gql`
  mutation ConfirmDeviceDocumentUpload(
    $deviceProfileId: Int!
    $documentType: DeviceDocumentType!
    $fileKey: String!
  ) {
    confirmDeviceDocumentUpload(
      deviceProfileId: $deviceProfileId
      documentType: $documentType
      fileKey: $fileKey
    )
  }
`;

export default CONFIRM_DEVICE_DOCUMENT_UPLOAD;
